module.exports = __webpack_public_path__ + "img/public/TrustIcons/verifyTickWhite.svg?bb0a6574";